module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _Tooltip = __webpack_require__(2);
    Object.defineProperty(exports, "default", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_Tooltip).default;
        }
    });
    var _TooltipStateless = __webpack_require__(8);
    Object.defineProperty(exports, "TooltipStateless", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_TooltipStateless).default;
        }
    });
}, /* 2 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _classCallCheck2 = __webpack_require__(3), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(4), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(5), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(6), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(7), _propTypes2 = _interopRequireDefault(_propTypes), _TooltipStateless = __webpack_require__(8), _TooltipStateless2 = _interopRequireDefault(_TooltipStateless), Tooltip = function(_PureComponent) {
        function Tooltip() {
            var _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, Tooltip);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, _PureComponent.call.apply(_PureComponent, [ this ].concat(args))), 
            _this.state = {
                isVisible: !1
            }, _this.hideTooltip = function() {
                return _this.setState({
                    isVisible: !1
                });
            }, _this.showTooltip = function() {
                return _this.setState({
                    isVisible: !0
                });
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(Tooltip, _PureComponent), Tooltip.prototype.render = function() {
            var _props = this.props, children = _props.children, description = _props.description, position = _props.position, target = _props.target, isVisible = this.state.isVisible;
            return _react2.default.createElement(_TooltipStateless2.default, {
                description: description,
                isVisible: isVisible,
                onMouseLeave: this.hideTooltip,
                onMouseEnter: this.showTooltip,
                position: position,
                target: target
            }, children);
        }, Tooltip;
    }(_react.PureComponent);
    Tooltip.propTypes = {
        /** The content the tooltip will be displayed around. */
        children: _propTypes2.default.node,
        /** The text to be displayed in the tooltip. */
        description: _propTypes2.default.string,
        /** Where the tooltip should appear relative to its children. */
        position: _propTypes2.default.oneOf([ "bottom", "left", "right", "top" ]),
        /**
	    Component to be rendered around the child. Can be used to adjust the size
	    and shape of the child.
	  */
        target: _propTypes2.default.oneOfType([ _propTypes2.default.func, _propTypes2.default.string ])
    }, Tooltip.defaultProps = {
        position: "bottom"
    }, exports.default = Tooltip;
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("prop-types");
}, /* 8 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _classCallCheck2 = __webpack_require__(3), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(4), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(5), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(6), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(7), _propTypes2 = _interopRequireDefault(_propTypes), _layer = __webpack_require__(9), _layer2 = _interopRequireDefault(_layer), _utils = __webpack_require__(10), _Tooltip = __webpack_require__(11), _Tooltip2 = _interopRequireDefault(_Tooltip), TooltipStateless = function(_PureComponent) {
        function TooltipStateless() {
            var _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, TooltipStateless);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, _PureComponent.call.apply(_PureComponent, [ this ].concat(args))), 
            _this.state = {
                isFlipped: !1
            }, _this.onMouseOver = function(e) {
                // eslint-disable-next-line no-console
                return _this.props.onMouseOver ? (console.warn("WARNING: onMouseOver() prop has been deprecated. This should be switched to onMouseEnter"), 
                _this.props.onMouseOver(e)) : null;
            }, _this.onMouseOut = function(e) {
                // eslint-disable-next-line no-console
                return _this.props.onMouseOut ? (console.warn("WARNING: onMouseOut() prop has been deprecated. This should be switched to onMouseLeave"), 
                _this.props.onMouseOut(e)) : null;
            }, _this.handleLayerFlipChange = function(_ref) {
                var flipped = _ref.flipped;
                _this.setState({
                    isFlipped: flipped
                });
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(TooltipStateless, _PureComponent), TooltipStateless.prototype.render = function() {
            var _props = this.props, children = _props.children, description = _props.description, isVisible = _props.isVisible, onMouseLeave = _props.onMouseLeave, onMouseEnter = _props.onMouseEnter, position = _props.position, Target = _props.target, isFlipped = this.state.isFlipped, tooltip = isVisible ? _react2.default.createElement(_Tooltip2.default, {
                isFlipped: isFlipped,
                position: position
            }, description) : null;
            return _react2.default.createElement(_layer2.default, {
                autoPosition: !0,
                content: tooltip,
                onFlippedChange: this.handleLayerFlipChange,
                position: (0, _utils.getLayerPosition)(position)
            }, _react2.default.createElement(Target, {
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseOver: this.onMouseOver,
                onMouseOut: this.onMouseOut
            }, children));
        }, TooltipStateless;
    }(_react.PureComponent);
    TooltipStateless.propTypes = {
        /** The content the tooltip will be displayed around. */
        children: _propTypes2.default.node,
        /** The text to be displayed in the tooltip. */
        description: _propTypes2.default.string,
        /** Set whether the tooltip is displayed or not. */
        isVisible: _propTypes2.default.bool,
        /** Function to be called when a mouse enters the target. */
        onMouseLeave: _propTypes2.default.func,
        /** Function to be called when a mouse leaves the target. */
        onMouseEnter: _propTypes2.default.func,
        /** onMouseOver is depreacted. Use onMouseEnter instead */
        onMouseOver: _propTypes2.default.func,
        /** onMouseOut is depreacted. Use onMouseLeave instead */
        onMouseOut: _propTypes2.default.func,
        /** Where the tooltip should appear relative to its children. */
        position: _propTypes2.default.oneOf([ "bottom", "left", "right", "top" ]),
        /**
	    Component to be rendered around the child. Can be used to adjust the size
	    and shape of the child. This will be passed the onMouseEnter and onMouseLeave
	    props.
	  */
        target: _propTypes2.default.oneOfType([ _propTypes2.default.func, _propTypes2.default.string ])
    }, TooltipStateless.defaultProps = {
        isVisible: !1,
        onMouseLeave: function() {},
        onMouseEnter: function() {},
        position: "bottom",
        target: _Tooltip.TooltipTarget
    }, exports.default = TooltipStateless;
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/layer");
}, /* 10 */
/***/
function(module, exports) {
    "use strict";
    // eslint-disable-next-line import/prefer-default-export
    function getLayerPosition(position) {
        var allowed = {
            bottom: "bottom center",
            left: "left middle",
            right: "right middle",
            top: "top center"
        };
        return allowed[position] || allowed.bottom;
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.getLayerPosition = getLayerPosition;
}, /* 11 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.TooltipTarget = void 0;
    var _taggedTemplateLiteral2 = __webpack_require__(12), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "translateY(", "px)" ], [ "translateY(", "px)" ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "translateX(", "px)" ], [ "translateX(", "px)" ]), _templateObject3 = (0, 
    _taggedTemplateLiteral3.default)([ "", "" ], [ "", "" ]), _templateObject4 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  animation: ", " ", "s ", "s backwards;\n  background-color: ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  color: ", ";\n  font-size: ", "px;\n  line-height: ", ";\n  margin: ", "px;\n  max-width: ", "px;\n  padding: ", "px ", "px;\n  pointer-events: none;\n  white-space: nowrap;\n" ], [ "\n  animation: ", " ", "s ", "s backwards;\n  background-color: ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  color: ", ";\n  font-size: ", "px;\n  line-height: ", ";\n  margin: ", "px;\n  max-width: ", "px;\n  padding: ", "px ", "px;\n  pointer-events: none;\n  white-space: nowrap;\n" ]), _templateObject5 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  display: inline-block;\n" ], [ "\n  display: inline-block;\n" ]), _styledComponents = __webpack_require__(13), _styledComponents2 = _interopRequireDefault(_styledComponents), _utilSharedStyles = __webpack_require__(14), _theme = __webpack_require__(15), createBold = _utilSharedStyles.akAnimationMixins.createBold, interpolate = _utilSharedStyles.akAnimationMixins.interpolate, grid = _utilSharedStyles.akGridSizeUnitless / 2, fontSize = 3 * grid, animDistance = 3 * grid, animDelay = .1, animTime = animDelay + 1, slideUp = {
        property: "transform",
        value: interpolate(_templateObject, function(t) {
            return t;
        }),
        deltas: [ {
            from: animDistance,
            to: 0
        } ]
    }, slideDown = {
        property: "transform",
        value: interpolate(_templateObject, function(t) {
            return t;
        }),
        deltas: [ {
            from: -animDistance,
            to: 0
        } ]
    }, slideLeft = {
        property: "transform",
        value: interpolate(_templateObject2, function(t) {
            return t;
        }),
        deltas: [ {
            from: animDistance,
            to: 0
        } ]
    }, slideRight = {
        property: "transform",
        value: interpolate(_templateObject2, function(t) {
            return t;
        }),
        deltas: [ {
            from: -animDistance,
            to: 0
        } ]
    }, fadeIn = {
        property: "opacity",
        deltas: [ {
            from: 0,
            to: 1
        } ]
    }, KEYFRAMES = {
        bottom: (0, _styledComponents.keyframes)(_templateObject3, createBold([ slideDown, fadeIn ])),
        left: (0, _styledComponents.keyframes)(_templateObject3, createBold([ slideLeft, fadeIn ])),
        right: (0, _styledComponents.keyframes)(_templateObject3, createBold([ slideRight, fadeIn ])),
        top: (0, _styledComponents.keyframes)(_templateObject3, createBold([ slideUp, fadeIn ]))
    }, KEYFRAMES_FLIPPED = {
        bottom: KEYFRAMES.top,
        left: KEYFRAMES.right,
        right: KEYFRAMES.left,
        top: KEYFRAMES.bottom
    }, getKeyframeName = function(_ref) {
        var isFlipped = _ref.isFlipped, position = _ref.position;
        return isFlipped ? KEYFRAMES_FLIPPED[position] : KEYFRAMES[position];
    }, backgroundColor = (0, _theme.themed)({
        light: _theme.colors.N800,
        dark: _theme.colors.DN0
    }), textColor = (0, _theme.themed)({
        light: _theme.colors.N0,
        dark: _theme.colors.DN600
    });
    // apply all the things
    exports.default = _styledComponents2.default.div(_templateObject4, getKeyframeName, animTime, animDelay, backgroundColor, _theme.borderRadius, textColor, fontSize, 4 * grid / fontSize, _theme.gridSize, _theme.math.multiply(_theme.gridSize, 52), _theme.math.divide(_theme.gridSize, 4), _theme.gridSize);
    // The inline-block here is needed to keep the tooltip appearing in the correct position
    // when nested inside a wider parent (see position: relative example).
    exports.TooltipTarget = _styledComponents2.default.div(_templateObject5);
}, /* 12 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/taggedTemplateLiteral");
}, /* 13 */
/***/
function(module, exports) {
    module.exports = require("styled-components");
}, /* 14 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/util-shared-styles");
}, /* 15 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/theme");
} ]);


//////////////////
// WEBPACK FOOTER
// ./~/@atlaskit/tooltip/dist/bundle-cjs.js
// module id = 365
// module chunks = 0